<template>
  <Aside
    class="niche-aside"
    :is-opened="isOpened"
    :variant="mainSectionComponent.variant"
    :show-header="false"
    :show-footer="false"
    user
    @close="cancel"
  >
    <div>
      <component
        :is="infoSectionComponent.component"
        v-if="infoSectionComponent"
        :aside-data.sync="asideData"
        is-mobile
        user
        @close="cancel"
        @enlist="$emit('enlist')"
      />
      <component :is="mainSectionComponent.component" :aside-data.sync="asideData" :mode="mode" />
    </div>
    <template v-if="infoSectionComponent" #info-section>
      <component
        :is="infoSectionComponent.component"
        :aside-data.sync="asideData"
        user
        @enlist="$emit('enlist')"
      />
    </template>
  </Aside>
</template>

<script>
import _ from 'lodash';
import { facultyToAsideData } from '@/store/faculties/user/faculties/mappers';
import Aside from '@/components/UiKit/v2/Aside';
import Button from '@/components/UiKit/v2/Button';
import Step4Main from './Steps/Step4/MainSection';
import Step4Info from './Steps/Step4/InfoSection';
import IconDefaulSquares from '@/style/icons/card-thumbs/default-squares.svg';

export default {
  name: 'FacultyAsideRoot',
  components: {
    Aside,
    Button
  },
  props: {
    isOpened: {
      type: Boolean,
      default: false
    },
    selectedNiche: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: [Object, Array],
      default: () => ({})
    },
    status: {
      type: Object,
      default: () => ({
        enabled: false,
        text: ''
      })
    },
    currentFaculty: {
      type: Object,
      default: () => ({})
    },
    facultyChanges: {
      type: Number,
      default: 1
    },
    mode: {
      type: String,
      default: 'show-faculty'
    }
  },
  data() {
    return {
      defaultAsideData: {},
      asideData: {
        stepData: {
          step1: {
            name: '',
            niche: {
              name: '',
              icon: IconDefaulSquares,
              background: '#F7F7FB'
            }
          },
          step2: {
            coachList: [],
            coachImageBlob: ''
          },
          step3: {
            youtubeVideoUrl: '',
            content: ''
          },
          step4: {},
          status: {
            enabled: false,
            text: '',
            type: 'primary',
            needConfirm: false,
            confirmText: ''
          },
          currentFaculty: {
            id: undefined
          },
          facultyChanges: 1
        },
        step: 1,
        steps: []
      }
    };
  },
  computed: {
    stepTotalCount() {
      return this.asideData.steps.length;
    },
    currentSectionComponent() {
      return this.asideData.steps[this.asideData.step - 1];
    },
    mainSectionComponent() {
      if (this.currentSectionComponent.components) {
        return this.currentSectionComponent.components.find(item => item.section === 'main');
      } else {
        return this.currentSectionComponent;
      }
    },
    infoSectionComponent() {
      if (this.currentSectionComponent.components) {
        return this.currentSectionComponent.components.find(item => item.section === 'info');
      } else {
        return null;
      }
    }
  },
  watch: {
    value(newValue) {
      if (newValue?.id) {
        this.asideData.stepData = {
          ...this.asideData.stepData,
          ...facultyToAsideData(newValue, this.options),
          currentFaculty: this.currentFaculty,
          facultyChanges: this.facultyChanges
        };
      } else {
        this.resetAsideData();
      }
    },
    status(value) {
      this.asideData.stepData.status = value;
    },
    currentFaculty(value) {
      this.asideData.stepData.currentFaculty = value;
    },
    facultyChanges(value) {
      this.asideData.stepData.facultyChanges = value;
    }
  },
  created() {
    this.setSteps();
    this.defaultAsideData = _.cloneDeep(this.asideData);
  },
  methods: {
    resetAsideData() {
      this.asideData = _.cloneDeep(this.defaultAsideData);
      this.asideData.stepData.options = this.options;
      this.asideData.stepData.currentFaculty = this.currentFaculty;
      this.asideData.stepData.facultyChanges = this.facultyChanges;
    },
    setSteps() {
      this.asideData.steps = [
        {
          components: [
            {
              component: Step4Main,
              variant: 'wide',
              section: 'main'
            },
            {
              component: Step4Info,
              variant: 'wide',
              section: 'info'
            }
          ]
        }
      ];
    },
    cancel() {
      this.$emit('close');
    },
    changeAsideData(data) {
      this.asideData = data;
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';

.niche-aside {
  $screen-sm: 600px;

  &__delete-btn.ui-kit-v2-button {
    color: #36383e;
    padding: 0;
    font-weight: normal;
    background-color: transparent;
    border: none;

    &::v-deep {
      svg {
        margin-right: 8px;
      }

      svg path {
        fill: #898989 !important;
      }
    }

    &:hover::v-deep {
      svg path {
        fill: $ui-red !important;
      }
    }
  }

  &::v-deep .step {
    &__card {
      &__coach-section {
        margin-bottom: 12px;
      }

      &__list li {
        margin-bottom: 8px;
      }

      &__coach-title {
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        margin-bottom: 8px;
      }

      &__business {
        color: $ui-black;
        font-weight: 500;
        font-size: 16px;
        margin-bottom: 16px;
        span {
          color: #ababba;
        }
      }
    }

    &__section--content {
      padding-bottom: 20px;

      &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;

        .ui-kit-file {
          display: contents;
        }
      }
    }

    &__section {
      &:not(:first-of-type) {
        margin-top: 32px;
        padding: 0 12px;
      }
    }

    &__title {
      margin-bottom: 16px;
      color: $ui-black-dark;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      display: flex;
    }

    &__description {
      color: $ui-gray-less-contrast;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 16px;
    }

    .input__wrapper,
    .selector {
      margin-bottom: 16px;
    }

    &__card {
      width: 100%;
      padding: 20px;
      background: #fff;
      box-shadow: 0 4px 10px rgba(43, 45, 52, 0.12);
      border-radius: 8px;

      &__title {
        margin-bottom: 12px;
        color: $ui-black-dark;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 20px;
      }

      ul {
        list-style-type: unset;
        list-style-position: inside;
        li {
          margin-bottom: 8px;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
